import React from "react";
import { LocationData, BannerData } from "./data";
import Banner from "../components/body/topLocationsComponents/Banner";
import Navbar from "../components/Navbar/Navbar";
import LocationCard from "../components/body/topLocationsComponents/LocationCard";
import Main_Footer from "../components/footer/IndiaFooter/Main_Footer";
const LocationPage = () => {
  return (
    <div>
      <Navbar />
      <Banner BannerData={BannerData} />
      <LocationCard LocationData={LocationData} />
      <Main_Footer />
    </div>
  );
};

export default LocationPage;
